import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import { ADVENTURE_GREEN, BACKGROUND_GRAY, ELEMENT_GRAY, INACTIVE_GRAY, LINE_GRAY, NIGHTINGALE_BLACK, RIOJA_RED, SENSATION_WHITE } from '../../colors';
import breakpoints from '../../breakpoints';
import { FONT_FAMILY_BASE } from '../../constants';
import { DROPDOWN_MULTI_HEIGHT } from './constants';
import { INPUT_CONTROL_HEIGHT } from '../constants';
import { Input } from '../../Typography/constants/input.size';
import { isDefined } from '../../helpers/defined';
var FONT_FAMILY = FONT_FAMILY_BASE;
var INPUT_CONTROL_HEIGHT_XS = INPUT_CONTROL_HEIGHT.xs,
    INPUT_CONTROL_HEIGHT_MD = INPUT_CONTROL_HEIGHT.md,
    INPUT_CONTROL_HEIGHT_XL = INPUT_CONTROL_HEIGHT.xl;
export { INPUT_CONTROL_HEIGHT_XS, INPUT_CONTROL_HEIGHT_MD, INPUT_CONTROL_HEIGHT_XL };
var DROPDOWN_MULTI_HEIGHT_XS = DROPDOWN_MULTI_HEIGHT.xs,
    DROPDOWN_MULTI_HEIGHT_MD = DROPDOWN_MULTI_HEIGHT.md,
    DROPDOWN_MULTI_HEIGHT_XL = DROPDOWN_MULTI_HEIGHT.xl; // TODO: re-done to styled components

export { DROPDOWN_MULTI_HEIGHT_XS, DROPDOWN_MULTI_HEIGHT_MD, DROPDOWN_MULTI_HEIGHT_XL };
var _Input$fontSize = Input.fontSize,
    INPUT_FONT_SIZE_XS = _Input$fontSize.xs,
    INPUT_FONT_SIZE_MD = _Input$fontSize.md,
    INPUT_FONT_SIZE_XL = _Input$fontSize.xl;
var _Input$lineHeight = Input.lineHeight,
    INPUT_LINE_HEIGHT_XS = _Input$lineHeight.xs,
    INPUT_LINE_HEIGHT_MD = _Input$lineHeight.md,
    INPUT_LINE_HEIGHT_XL = _Input$lineHeight.xl;

var text = function text(props, _temp) {
  var _objectSpread2;

  var _ref = _temp === void 0 ? {} : _temp,
      _ref$isOption = _ref.isOption,
      isOption = _ref$isOption === void 0 ? false : _ref$isOption,
      _ref$withHeight = _ref.withHeight,
      withHeight = _ref$withHeight === void 0 ? false : _ref$withHeight;

  return _objectSpread(_objectSpread({
    fontFamily: FONT_FAMILY,
    fontSize: INPUT_FONT_SIZE_XS,
    fontWeight: 400,
    letterSpacing: 0,
    fontStyle: 'normal',
    fontStretch: 'normal',
    textTransform: 'none',
    WebkitFontSmoothing: 'antialiased',
    MozOsxFontSmoothing: 'grayscale',
    lineHeight: isOption ? INPUT_LINE_HEIGHT_XS : DROPDOWN_MULTI_HEIGHT_XS
  }, withHeight ? {
    height: DROPDOWN_MULTI_HEIGHT_XS
  } : {}), {}, (_objectSpread2 = {}, _objectSpread2["@media (min-width: " + breakpoints.md.min + "px)"] = _objectSpread({
    fontSize: INPUT_FONT_SIZE_MD,
    lineHeight: isOption ? INPUT_LINE_HEIGHT_MD : DROPDOWN_MULTI_HEIGHT_MD
  }, withHeight ? {
    height: DROPDOWN_MULTI_HEIGHT_MD
  } : {}), _objectSpread2["@media (min-width: " + breakpoints.xl.min + "px)"] = _objectSpread({
    fontSize: INPUT_FONT_SIZE_XL,
    lineHeight: isOption ? INPUT_LINE_HEIGHT_XL : DROPDOWN_MULTI_HEIGHT_XL
  }, withHeight ? {
    height: DROPDOWN_MULTI_HEIGHT_XL
  } : {}), _objectSpread2));
}; // * This file extends react-select inner components styles
// * each key corresponds to a component in react-select


var styles = function styles(props) {
  return {
    indicatorSeparator: function indicatorSeparator(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        display: 'none'
      });
    },
    clearIndicator: function clearIndicator(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        padding: 0
      });
    },
    dropdownIndicator: function dropdownIndicator(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        padding: 0
      });
    },
    indicatorContainer: function indicatorContainer(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        padding: 0
      });
    },
    container: function container(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        fontFamily: FONT_FAMILY
      });
    },
    placeholder: function placeholder(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        transform: 'none',
        top: 'auto',
        marginLeft: 0,
        marginRight: 0,
        color: INACTIVE_GRAY
      }, text(props, {
        withHeight: true
      }));
    },
    valueContainer: function valueContainer(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        padding: 0
      });
    },
    input: function input(styles) {
      return _objectSpread(_objectSpread(_objectSpread({}, styles), {}, {
        color: NIGHTINGALE_BLACK,
        margin: 0,
        padding: 0,
        paddingTop: 0,
        paddingBottom: 0
      }, text(props, {
        withHeight: true
      })), {}, {
        '& > div': _objectSpread({
          paddingBottom: 0,
          paddingTop: 0
        }, text(props, {
          withHeight: true
        })),
        '& > div > input': _objectSpread({}, text(props, {
          withHeight: true
        }))
      });
    },
    control: function control(styles, _ref2) {
      var _objectSpread3;

      var isDisabled = _ref2.isDisabled,
          isFocused = _ref2.isFocused;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, styles), text(props)), {}, {
        backgroundColor: isDisabled ? BACKGROUND_GRAY : SENSATION_WHITE,
        borderRadius: '4px',

        /* prettier-ignore */
        borderColor: !props.hideErrorOnFocus && props.error ? RIOJA_RED : isFocused ? ADVENTURE_GREEN : props.error ? RIOJA_RED : ELEMENT_GRAY,
        boxShadow: 'none',
        outline: 'none'
      }, isDisabled ? {
        cursor: 'not-allowed',
        pointerEvents: 'all'
      } : {}), {}, (_objectSpread3 = {
        alignItems: 'stretch',
        minHeight: INPUT_CONTROL_HEIGHT_XS
      }, _objectSpread3["@media (min-width: " + breakpoints.md.min + "px)"] = {
        minHeight: INPUT_CONTROL_HEIGHT_MD
      }, _objectSpread3["@media (min-width: " + breakpoints.xl.min + "px)"] = {
        minHeight: INPUT_CONTROL_HEIGHT_XL
      }, _objectSpread3[':active'] = {
        outline: 'none'
      }, _objectSpread3[':focus'] = {
        outline: 'none'
      }, _objectSpread3[':hover'] = {
        /* prettier-ignore */
        borderColor: !props.hideErrorOnFocus && props.error ? RIOJA_RED : isFocused ? ADVENTURE_GREEN : props.error ? RIOJA_RED : ELEMENT_GRAY
      }, _objectSpread3), props.withPrefix ? {
        borderLeft: 0,
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      } : {}), props.withSuffix ? {
        borderRight: 0,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      } : {});
    },
    menu: function menu(styles) {
      var _props$menuZIndex;

      return _objectSpread(_objectSpread({}, styles), {}, {
        boxShadow: 'none',
        backgroundColor: 'transparent',
        zIndex: (_props$menuZIndex = props.menuZIndex) != null ? _props$menuZIndex : 1
      });
    },
    menuPortal: function menuPortal(styles) {
      return _objectSpread(_objectSpread({}, styles), isDefined(props.menuZIndex) ? {
        zIndex: props.menuZIndex
      } : {});
    },
    multiValue: function multiValue(styles) {
      var _objectSpread4;

      return _objectSpread(_objectSpread({}, styles), {}, (_objectSpread4 = {
        margin: 0,
        backgroundColor: LINE_GRAY,
        borderRadius: 48,
        fontFamily: FONT_FAMILY,
        fontSize: INPUT_FONT_SIZE_XS,
        lineHeight: INPUT_LINE_HEIGHT_XS
      }, _objectSpread4["@media (min-width: " + breakpoints.md.min + "px)"] = {
        fontSize: INPUT_FONT_SIZE_MD,
        lineHeight: INPUT_LINE_HEIGHT_MD
      }, _objectSpread4["@media (min-width: " + breakpoints.xl.min + "px)"] = {
        fontSize: INPUT_FONT_SIZE_XL,
        lineHeight: INPUT_LINE_HEIGHT_XL
      }, _objectSpread4));
    },
    multiValueLabel: function multiValueLabel() {
      var _ref3;

      return _ref3 = {
        color: NIGHTINGALE_BLACK,
        borderRadius: 48,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        boxSizing: 'border-box',
        padding: '3px 0px 3px 16px'
      }, _ref3["@media (min-width: " + breakpoints.md.min + "px)"] = {
        padding: '2px 2px 2px 16px'
      }, _ref3["@media (min-width: " + breakpoints.xl.min + "px)"] = {
        padding: '4px 4px 4px 20px'
      }, _ref3;
    },
    multiValueRemove: function multiValueRemove() {
      return {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        borderRadius: '100%'
      };
    },
    loadingMessage: function loadingMessage(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: INACTIVE_GRAY
      }, text(props, {
        isOption: true
      }));
    },
    noOptionsMessage: function noOptionsMessage(styles) {
      return _objectSpread(_objectSpread({}, styles), {}, {
        color: INACTIVE_GRAY
      }, text(props, {
        isOption: true
      }));
    }
  };
};

export default styles;